import React, { useState } from 'react';
import { CloseIcon } from '../components/setup-guide/svg';
import moment from 'moment';
import { convertTo12HourFormat } from '../helpers/constants';
import { useDispatch, useSelector } from 'react-redux';
import { cancelAppointment } from '../redux/appointments/appointmentAction';
import { Spin } from 'antd';

const ManageAppointment = ({
    toggle,
    isOpen,
    selectedAppointment,
    setSelectedAppointment,
}) => {

    console.log('selectedAppointment: ', selectedAppointment);
    const dispatch = useDispatch();
    const { isCancellingAppointment } = useSelector(
        (state) => state.appointments
    );

    const [isCancellationOpen, setIsCancellationOpen] = useState(false);
    const [isRefundOpen, setIsRefundOpen] = useState(false);

    const totalAmount = parseFloat(selectedAppointment?.amount) || 0;
    const isCash = selectedAppointment?.type === 'cash';
    const remainingAmountVal = isCash
        ? totalAmount
        : (selectedAppointment?.remainingAmount !== undefined && selectedAppointment?.remainingAmount !== null)
            ? parseFloat(selectedAppointment?.remainingAmount)
            : (totalAmount * 0.80);
    const remainingAmount = remainingAmountVal.toFixed(2);
    const depositPaid = isCash ? '0.00' : (totalAmount - remainingAmountVal).toFixed(2);

    const getCancellationText = () => {
        const business = selectedAppointment?.appointmentService?.[0]?.service?.business || selectedAppointment?.business;
        const type = business?.cancellationType || 'flexible';

        if (type.toLowerCase() === 'strict') {
            return 'Deposit is non-refundable.';
        } else if (type.toLowerCase() === 'flexible') {
            return 'Free cancellation up to 24 hours before the appointment. (1 day before appointment)';
        } else {
            return 'Free cancellation up to 48 hours before the appointment. (2 days before appointment)';
        }
    };

    const checkRemainingHours = (targetDate, targetTime) => {
        if (isCash) {
            return 'No refund is applicable for this booking as it was booked with the Cash payment method.';
        }
        if (!targetDate || !targetTime) return '';

        // Combine date and time into a single moment object
        const targetDateTime = moment(targetDate).set({
            hour: parseInt(targetTime.split(':')[0]) || 0,
            minute: parseInt(targetTime.split(':')[1]) || 0,
        });

        // Current date and time
        const now = moment();

        // Calculate the difference in hours
        const diffInHours = targetDateTime.diff(now, 'hours', true);
        let fullRefund = `You will receive refund of £${depositPaid} in next 30 mins`;
        let noRefund = 'You will not receive refund for this appointment';

        const business = selectedAppointment?.appointmentService?.[0]?.service?.business || selectedAppointment?.business;
        const type = business?.cancellationType || 'flexible';

        if (type.toLowerCase() === 'strict') {
            return noRefund;
        } else if (type.toLowerCase() === 'flexible') {
            if (diffInHours < 24) {
                return noRefund;
            } else {
                return fullRefund;
            }
        } else if (type.toLowerCase() === 'moderate') {
            if (diffInHours < 48) {
                return noRefund;
            } else {
                return fullRefund;
            }
        } else {
            return fullRefund;
        }
    };

    return (
        <div
            className={`modal manage-appointment-modal right-modal ${!isOpen ? 'd-none' : ''}`}
        >
            <div className={`right-modal-content`} style={{ maxWidth: '420px', display: 'flex', flexDirection: 'column', height: '100vh', boxShadow: '-4px 0 24px rgba(0,0,0,0.15)' }}>
                <div className={`right-modal-header`} style={{ padding: '20px 24px', borderBottom: '1px solid #eaecf0' }}>
                    <div className={`container-fluid`}>
                        <div className={`row align-items-center`}>
                            <div className={`col px-0`}>
                                <h3
                                    className={`fs-20 fw-semibold poly color-primary m-0`}
                                    style={{ color: '#2b5c35', fontFamily: 'Poppins' }}
                                >
                                    Manage Appointment
                                </h3>
                            </div>
                            <div className={`col-auto px-0`}>
                                <div
                                    className={`cp d-flex align-items-center justify-content-center`}
                                    onClick={toggle}
                                    style={{
                                        width: '36px',
                                        height: '36px',
                                        borderRadius: '50%',
                                        border: '1px solid #eaecf0',
                                        transition: 'all 0.2s',
                                        cursor: 'pointer'
                                    }}
                                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#f9fafb'}
                                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                                >
                                    <CloseIcon />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`right-modal-body`} style={{ padding: '24px', overflowY: 'auto', flex: 1 }}>
                    <div className={`container-fluid px-0`}>

                        {/* Card 1: Services & Time Info */}
                        <div className="p-3 mb-4" style={{ backgroundColor: '#f9fafb', borderRadius: '12px', border: '1px solid #eaecf0' }}>
                            <p className="poppins fw-semibold text-dark mb-2" style={{ fontSize: '15px' }}>
                                Appointment Details
                            </p>
                            <div className="d-flex flex-column gap-2 mb-3">
                                {selectedAppointment?.appointmentService?.map((item, idx) => (
                                    <div key={idx} className="d-flex align-items-center gap-2">
                                        <span style={{ width: '6px', height: '6px', borderRadius: '50%', backgroundColor: '#2b5c35' }}></span>
                                        <span className="poppins fw-medium text-dark text-capitalize" style={{ fontSize: '14px' }}>
                                            {item?.service?.name}
                                        </span>
                                    </div>
                                ))}
                            </div>

                            <div className="d-flex align-items-center gap-4 pt-3 border-top" style={{ borderColor: '#eaecf0' }}>
                                <div className="d-flex align-items-center gap-2 text-muted" style={{ fontSize: '13.5px' }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#667085" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                                        <line x1="16" y1="2" x2="16" y2="6"></line>
                                        <line x1="8" y1="2" x2="8" y2="6"></line>
                                        <line x1="3" y1="10" x2="21" y2="10"></line>
                                    </svg>
                                    <span className="poppins fw-medium">
                                        {selectedAppointment?.date && moment(selectedAppointment?.date).format('DD/MM/YYYY')}
                                    </span>
                                </div>
                                <div className="d-flex align-items-center gap-2 text-muted" style={{ fontSize: '13.5px' }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#667085" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <polyline points="12 6 12 12 16 14"></polyline>
                                    </svg>
                                    <span className="poppins fw-medium">
                                        {selectedAppointment?.time && convertTo12HourFormat(selectedAppointment?.time)}
                                    </span>
                                </div>
                            </div>
                        </div>

                        {/* Card 2: Pricing & Deposit Breakdown */}
                        <div className="p-3 mb-4" style={{ backgroundColor: '#ffffff', borderRadius: '12px', border: '1px solid #eaecf0', boxShadow: '0px 1px 3px rgba(16, 24, 40, 0.05)' }}>
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <p className="poppins fw-semibold text-dark m-0" style={{ fontSize: '15px' }}>
                                    Payment Summary
                                </p>
                                {selectedAppointment?.status === 'completed' && (
                                    <span className="poppins fw-semibold text-success px-2 py-1" style={{ fontSize: '12px', backgroundColor: '#e8f4ec', borderRadius: '6px' }}>
                                        Paid in Full
                                    </span>
                                )}
                                {selectedAppointment?.status === 'canceled' && (
                                    <span className="poppins fw-semibold text-danger px-2 py-1" style={{ fontSize: '12px', backgroundColor: '#fef3f2', borderRadius: '6px' }}>
                                        Canceled
                                    </span>
                                )}
                            </div>
                            <div className="d-flex justify-content-between mb-2">
                                <span className="poppins text-muted" style={{ fontSize: '13.5px' }}>Total Service Value:</span>
                                <span className="poppins fw-semibold text-dark" style={{ fontSize: '13.5px' }}>£{totalAmount.toFixed(2)}</span>
                            </div>
                            {!isCash && (
                                <div className="d-flex justify-content-between mb-2 align-items-center">
                                    <span className="poppins text-muted" style={{ fontSize: '13.5px' }}>
                                        {selectedAppointment?.status === 'canceled' 
                                            ? 'Deposit Forfeited/Refunded (20%):' 
                                            : 'Deposit Paid Online (20%):'}
                                    </span>
                                    <span className="poppins fw-bold text-success" style={{ fontSize: '13.5px', backgroundColor: '#e8f4ec', padding: '2px 8px', borderRadius: '6px' }}>£{depositPaid}</span>
                                </div>
                            )}
                            <div className="d-flex justify-content-between pt-3 mt-2 border-top align-items-center" style={{ borderColor: '#eaecf0' }}>
                                <span className="poppins text-dark fw-semibold" style={{ fontSize: '14px' }}>
                                    {selectedAppointment?.status === 'completed' 
                                        ? 'Paid at Salon:' 
                                        : selectedAppointment?.status === 'canceled' 
                                        ? 'Remaining Balance (Canceled):' 
                                        : 'Remaining to Pay at Salon:'}
                                </span>
                                <span className="poppins fw-bold text-dark" style={{ fontSize: '16px' }}>
                                    £{selectedAppointment?.status === 'canceled' ? '0.00' : remainingAmount}
                                </span>
                            </div>
                        </div>

                        {/* Card 3: Policies & Actions */}
                        {selectedAppointment?.status &&
                            selectedAppointment?.status !== 'completed' && (
                                <div className="d-flex flex-column gap-3 mb-2">
                                    <div className="p-3" style={{ backgroundColor: '#fff8f6', borderRadius: '12px', border: '1px solid #ffe4e0' }}>
                                        <div 
                                            className="d-flex align-items-center justify-content-between mb-2 text-danger cp" 
                                            onClick={() => setIsCancellationOpen(!isCancellationOpen)}
                                            style={{ cursor: 'pointer', userSelect: 'none' }}
                                        >
                                            <div className="d-flex align-items-center gap-2">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#d92d20" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                                    <circle cx="12" cy="12" r="10"></circle>
                                                    <line x1="12" y1="8" x2="12" y2="12"></line>
                                                    <line x1="12" y1="16" x2="12.01" y2="16"></line>
                                                </svg>
                                                <span className="poppins fw-semibold" style={{ fontSize: '14px', color: '#d92d20' }}>Cancellation Policy</span>
                                            </div>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#d92d20" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ transform: isCancellationOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s' }}>
                                                <polyline points="6 9 12 15 18 9"></polyline>
                                            </svg>
                                        </div>
                                        {isCancellationOpen && selectedAppointment && (
                                            <p className="poppins text-muted mb-3" style={{ fontSize: '13px', lineHeight: '18px', color: '#475467' }}>
                                                {getCancellationText()}
                                            </p>
                                        )}

                                        {selectedAppointment && (
                                            <>
                                                <div 
                                                    className={`d-flex align-items-center justify-content-between mb-2 text-danger cp ${isCancellationOpen ? 'mt-3' : ''}`}
                                                    onClick={() => setIsRefundOpen(!isRefundOpen)}
                                                    style={{ cursor: 'pointer', userSelect: 'none' }}
                                                >
                                                    <div className="d-flex align-items-center gap-2">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#d92d20" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                                            <circle cx="12" cy="12" r="10"></circle>
                                                            <line x1="12" y1="8" x2="12" y2="12"></line>
                                                            <line x1="12" y1="16" x2="12.01" y2="16"></line>
                                                        </svg>
                                                        <span className="poppins fw-semibold" style={{ fontSize: '14px', color: '#d92d20' }}>Refund Policy</span>
                                                    </div>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#d92d20" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ transform: isRefundOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s' }}>
                                                        <polyline points="6 9 12 15 18 9"></polyline>
                                                    </svg>
                                                </div>
                                                {isRefundOpen && selectedAppointment?.date && selectedAppointment?.time && (
                                                    <p className="poppins text-muted mb-0" style={{ fontSize: '13px', lineHeight: '18px', color: '#475467' }}>
                                                        {checkRemainingHours(selectedAppointment?.date, selectedAppointment?.time)}
                                                    </p>
                                                )}
                                            </>
                                        )}
                                    </div>

                                    {(selectedAppointment?.status === 'canceled' ||
                                        selectedAppointment?.appointmentService[0]?.service?.business?.cancellationType?.toLowerCase() !== 'strict') && (
                                            <button
                                                className="w-100 fs-15 poppins py-3 transition-all fw-semibold mt-3 d-flex align-items-center justify-content-center border-0"
                                                style={{
                                                    color: '#ffffff',
                                                    backgroundColor: '#dc3027',
                                                    borderRadius: '8px',
                                                    cursor: 'pointer',
                                                    boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)',
                                                    minHeight: '48px'
                                                }}
                                                onClick={() => {
                                                    let isRefunded = true;
                                                    if (selectedAppointment?.date && selectedAppointment?.time) {
                                                        const targetDateTime = moment(selectedAppointment.date).set({
                                                            hour: parseInt(selectedAppointment.time.split(':')[0]) || 0,
                                                            minute: parseInt(selectedAppointment.time.split(':')[1]) || 0,
                                                        });
                                                        const now = moment();
                                                        const diffInHours = targetDateTime.diff(now, 'hours', true);
                                                        
                                                        const business = selectedAppointment?.appointmentService?.[0]?.service?.business || selectedAppointment?.business;
                                                        const type = business?.cancellationType || 'flexible';
                                                        
                                                        if (type.toLowerCase() === 'strict') {
                                                            isRefunded = false;
                                                        } else if (type.toLowerCase() === 'flexible' && diffInHours < 24) {
                                                            isRefunded = false;
                                                        } else if (type.toLowerCase() === 'moderate' && diffInHours < 48) {
                                                            isRefunded = false;
                                                        }
                                                    } else {
                                                        isRefunded = false;
                                                    }
                                                    
                                                    dispatch(
                                                        cancelAppointment(
                                                            selectedAppointment?.id,
                                                            isRefunded,
                                                            depositPaid,
                                                            () => {
                                                                toggle();
                                                                setSelectedAppointment(null);
                                                            }
                                                        )
                                                    );
                                                }}
                                                disabled={isCancellingAppointment}
                                                onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#b91c1c'}
                                                onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#dc3027'}
                                            >
                                                {isCancellingAppointment ? <Spin /> : 'Cancel Appointment'}
                                            </button>
                                        )}
                                </div>
                            )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ManageAppointment;
